import tieredPricingRules from "./../../tieredPricingRules.json";
import TieredPricingOption from "./TieredPricingOption";

export default function TieredPricingOptions({attributes}) {

    const wrapperStyle = {}

    return (
        <div style={wrapperStyle}>
            <style dangerouslySetInnerHTML={{
                __html: [
                    '.tiered-pricing-option-checkbox--active:after {' +
                    'background:' + attributes.activeTierColor +
                    '}\n' +

                    '.tiered-pricing-option-checkbox--active {' +
                    'border-color:' + attributes.activeTierColor +
                    '}\n'
                ].join('\n')
            }}>
            </style>

            {tieredPricingRules.map(rule => {
                return <TieredPricingOption
                    attributes={attributes} isSelected={rule.isSelected} key={rule.quantity}
                    quantity={rule.quantity} discount={rule.discount} price={rule.price}/>
            })}
        </div>
    )
}
